"use client";

import { getBorderRadius, getDesktop, getMobile } from "@/utils/theme-helper";

export interface ImageComponentProps {
  url: string;
  altText: string;
  height: string;
  width: string;
  objectFit: string;
  objectPosition?: string;
  rounded?: string;
  aspectRatio?: string;
}

const ImageComponent: React.FC<{
  config: ImageComponentProps;
}> = ({ config }) => {
  const mobileWidth = getMobile("w-full", config.width);
  const desktopWidth = getDesktop("w-full", config.width);
  const mobileHeight = getMobile("h-full", config.height);
  const desktopHeight = getDesktop("h-full", config.height);

  const mobileAspectRatio = getMobile("auto", config.aspectRatio);
  const desktopAspectRatio = getDesktop("auto", config.aspectRatio);

  if (!config.url) {
    return null;
  }

  return (
    <img
      src={config.url}
      alt={config.altText ?? "billede"}
      style={
        {
          "--mobile-width": mobileWidth,
          "--desktop-width": desktopWidth,
          "--mobile-height": mobileHeight,
          "--desktop-height": desktopHeight,
          objectPosition: config.objectPosition ?? "center",
          "--mobile-aspect-ratio": mobileAspectRatio,
          "--desktop-aspect-ratio": desktopAspectRatio,
          "--rounding-image-mobile": getBorderRadius(
            getMobile("", config.rounded),
            "image"
          ),
          "--rounding-image-desktop": getBorderRadius(
            getDesktop("", config.rounded),
            "image"
          ),
        } as React.CSSProperties
      }
      className={`homepage-image-rounded object-${config.objectFit ?? "cover"} ${mobileWidth !== "none" ? "w-[var(--mobile-width)]" : "w-full"} ${desktopWidth !== "none" ? "md:w-[var(--desktop-width)]" : "w-full"} ${mobileHeight !== "none" ? "h-[var(--mobile-height)]" : "h-full"} ${desktopHeight !== "none" ? "md:h-[var(--desktop-height)]" : "h-full"} overflow-hidden aspect-[var(--mobile-aspect-ratio)] md:aspect-[var(--desktop-aspect-ratio)]`}
    />
  );
};

export default ImageComponent;
